import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { action_setBoardChartContainerIdSelected } from '../../../../../../reducers/actions/KPI/actions';

const useSetFirstLoadSelectedContainerId = (containerId, dataserieId, selectedItem) => {  
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                dispatch(action_setBoardChartContainerIdSelected({
                    containerId: containerId,
                    dataserieId: dataserieId
                }));
            }
            catch (error) {

            }
        }
        
        if (selectedItem === undefined || (selectedItem.containerId === null && selectedItem.dataserieId == null)) {
            getData()
        }
    }, [containerId, dataserieId, selectedItem]);
}

export {
    useSetFirstLoadSelectedContainerId,
}